export interface ChangelogEntry {
  version: string;
  date: string;
  changes: string[];
}

export const adminChangelog: ChangelogEntry[] = [
  {
    version: 'v0.6.26-node-expiry',
    date: '2026-08-17',
    changes: [
      '新增服务器与节点到期通知中心，支持未读、忽略和按类型/级别筛选',
      '新增节点到期后台扫描，续费、删除或清空有效期后自动关闭提醒',
      '新增 SMTP 即时邮件、每日汇总、测试邮件与 QQ 邮箱 SSL 预设',
      '合并游戏服实时连接峰值的满 2 小时统计逻辑，避免发布回退',
    ],
  },
  {
    version: 'v0.6.18-node-delete',
    date: '2026-07-07',
    changes: [
      '服务器卡片操作菜单新增“删除服务器”入口，复用后端 active/creating 节点保护',
      '删除节点前增加明确风险确认，避免误删仍在运行或仍有历史数据的节点',
      '修复线上主机 sudo hostname 解析提示，减少运维日志噪音',
    ],
  },
  {
    version: 'v0.6.17-disk-health',
    date: '2026-07-07',
    changes: [
      '节点心跳新增磁盘使用率字段，节点列表、详情与 dashboard 可直接查看磁盘占用',
      '新增 nodes.disk_percent 迁移并同步 node_stats 视图，兼容旧 agent 未上报字段的情况',
      '优化节点卡片资源指标展示，CPU/MEM/DSK 同屏显示，便于快速判断机器健康状态',
    ],
  },
  {
    version: 'v0.6.17',
    date: '2026-07-06',
    changes: [
      '新增节点运维模块：节点 SSH 凭据保存、连通性校验、远程动作执行与操作记录',
      '新增掉线审计链路：接收并落库 agent 上报的连接关闭事件',
      '节点详情升级为标签页（信息 / 实时连接 / 掉线审计），便于排查用户投诉',
      '创建节点增加服务器到期约束校验，避免“服务器先过期、节点仍有效”',
    ],
  },
  {
    version: 'v0.6.7-zerostate',
    date: '2026-07-06',
    changes: [
      '修复 admin 控制面关键稳定性问题（扫描鉴权、节点删除防护、WS 路径收敛）',
      '补强 agent 重连后指标恢复链路，降低“节点在线但数据不更新”概率',
      '设置页加入版本信息与多节点 agent 版本对比提示',
    ],
  },
  {
    version: 'v0.6.16-region-lines-filter',
    date: '2026-07-05',
    changes: [
      '新增线路页多维筛选：按大区、服务器文本检索线路状态',
      '线路状态增强：支持“满线（status=250）”标签展示',
      '增强 region line scanner 的 API、状态留存与历史查询能力',
    ],
  },
  {
    version: 'v0.6.16-billing',
    date: '2026-07-04',
    changes: [
      '新增计费看板：收入/成本/利润与按节点拆分统计',
      '节点支持 total_cost_cents 成本字段，创建/编辑/列表全链路打通',
      '补齐历史节点 tier 归类与计费查询兼容修复',
    ],
  },
  {
    version: 'v0.6.15-version-card',
    date: '2026-07-03',
    changes: [
      '新增 `GET /api/version` 与设置页版本卡片',
      '统一展示 admin 版本、git sha、构建时间与运行时信息',
      '同步前端 embed 产物，降低“页面看不到更新”的定位成本',
    ],
  },
  {
    version: 'v0.6.14',
    date: '2026-07-02',
    changes: [
      '新增节点续费能力：支持延长到期时间且不重建节点',
      '创建节点支持自定义 `Nd/Nm` 时长并加强参数校验',
      '补齐节点备注、健康检查、批量筛选等管理能力',
    ],
  },
  {
    version: 'v0.6.13',
    date: '2026-07-01',
    changes: [
      '引入多大区节点模型（`proxy_regions`），支持单节点覆盖多个大区',
      '分配器升级：按节点占用大区/端口状态进行更稳健调度',
      '补齐卡节点创建的重派发与掉线恢复逻辑',
    ],
  },
  {
    version: 'v0.6.12',
    date: '2026-06-30',
    changes: [
      '升级节点运维基础能力：节点到期、安装命令、IP 公网地址编辑',
      '优化 dashboard 与 proxy 列表展示，减少一线运维沟通成本',
      '增加 settings 默认并改进多端可见性',
    ],
  },
  {
    version: 'v0.6.11-live-dns-sync',
    date: '2026-06-29',
    changes: [
      '大区同步改为实时 DNS 解析，支持 unresolved_domains 追踪',
      '新增 DNS 上游配置与容错回退策略（超时/并发/失败处理）',
      '前端显示 unresolved 结果，便于快速判断线路数据质量',
    ],
  },
  {
    version: 'v0.6.6',
    date: '2026-07-04',
    changes: [
      '加强服务器与节点控制路径稳定性，修复部分 ACK 超时场景',
      '补充节点删除与扫描相关鉴权/测试覆盖',
      '前端服务器与节点展示细节优化，减少误操作和信息重叠',
    ],
  },
  {
    version: 'v0.6.5',
    date: '2026-07-03',
    changes: [
      '新增/完善区域与线路同步相关能力，改进管理后台可观测性',
      '补强节点列表性能与若干 API 细节',
    ],
  },
];

export const agentChangelog: ChangelogEntry[] = [
  {
    version: 'v0.3.22-disk-health',
    date: '2026-07-07',
    changes: [
      'heartbeat 新增根文件系统磁盘使用率上报，admin 可直接展示节点磁盘健康状态',
      'child control socket 在退出时主动清理，supervisor 启动时清理 PID 已不存在的旧 child socket',
      '补充 socket 清理与磁盘指标测试，降低旧 socket 残留影响运维判断的概率',
    ],
  },
  {
    version: 'v0.3.6',
    date: '2026-07-06',
    changes: [
      '新增连接关闭事件上报（close_side/close_reason/error_detail）供 admin 掉线审计',
      '优化 supervisor 与 metrics 协作，减少重连后指标断流问题',
      '补强 child watcher 与 proxy_died 事件一致性',
    ],
  },
  {
    version: 'v0.3.5',
    date: '2026-07-06',
    changes: [
      '增强 child 管理与异常恢复路径，降低误杀和状态漂移概率',
      '完善 proxy_died 上报与 watcher 行为，减少重连期间事件丢失',
      '补充本地/集成测试用例，提升升级回归可靠性',
    ],
  },
  {
    version: 'v0.3.4',
    date: '2026-07-04',
    changes: [
      '增强 server_select 抓包能力，支持上行选服与下行服务器列表识别',
      '新增选择事件缓冲与 heartbeat 批量上报到 admin',
      '改进 orphan adopt 与端口持有者识别，降低升级误伤',
    ],
  },
  {
    version: 'v0.3.3',
    date: '2026-07-03',
    changes: [
      '优化 SOCKS5 握手/CONNECT/目标连接超时控制',
      '细化连接关闭原因分类，提升“掉线甩锅”可解释性',
      '改进并发限制与黑名单路径稳定性',
    ],
  },
  {
    version: 'v0.2.9',
    date: '2026-07-04',
    changes: [
      '优化 Socks5 连接超时与错误分类逻辑，提升掉线原因可解释性',
      '加强 metrics 与心跳协作路径，改善 admin 侧状态恢复速度',
    ],
  },
  {
    version: 'v0.2.8-compat',
    date: '2026-07-02',
    changes: [
      '保持与新旧 admin 控制协议的兼容重连路径',
      '修复若干边界条件下的 child 生命周期问题',
      '为后续 zerostate 演进提供稳定过渡版本',
    ],
  },
  {
    version: 'v0.2.8',
    date: '2026-07-02',
    changes: [
      '维持与新旧 admin 的兼容重连路径',
      '修复若干连接边界条件，增强长时间运行稳定性',
    ],
  },
];
